
export default 'ivu-date-picker-cells';


// WEBPACK FOOTER //
// ./src/components/date-picker/base/prefixCls.js